<template>
  <div class="cell" v-bind:class="{on:on, hint: hint}" v-on:click="clickHandler"></div>
</template>

<script>
export default {
  props: ["on", "onClick", "x", "y", "hint"],
  methods: {
    clickHandler() {
      this.onClick({ x: this.x, y: this.y });
    }
  }
};
</script>

<style scoped>
.cell {
  box-sizing: border-box;
  width: 45px;
  height: 45px;
  border: 2px solid var(--color);
  border-radius: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  transition: 0.3s;
  cursor: pointer;
}
.on {
  background: var(--color);
}
.hint {
    animation: hint 2s infinite;
}
.cell:hover {
  border-color: #ffffff;
}
@keyframes hint {
  0% {
    border-color: var(--color);
  }
  50% {
    border-color: #fff;
    box-shadow: 0 0 5px 0 #fff, 0 0 5px 0 #fff inset;
  }
  100% {
    border-color: var(--color);
  }
}
</style>
